import { Certificate } from 'src/app/shared/models/certificate';
import { Component, Input, OnInit } from '@angular/core';
import { CandidateStore } from '../../../../store/candidate-store';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-certificate-form',
  templateUrl: './certificate-form.component.html',
  styleUrls: ['./certificate-form.component.scss']
})
export class CertificateFormComponent implements OnInit {
  @Input() shouldCollapse: boolean;
  form: FormGroup;

  constructor(public dashboardState: CandidateStore, private formBuilder: FormBuilder,) { }

  ngOnInit() {
    this.form = this.formBuilder.group(
      {
        title: [''],
      }
    );

  }

  setTitle = (index: number) => {
    const certificate = this.form.value as Certificate;
    this.dashboardState.updateCertificate(index, certificate);
  }

  addCertificate = () => {
    this.dashboardState.addCertificate(new Certificate());
  }

  save = () => { }

  removeCertificate = (index: number) => {
    this.dashboardState.removeCertificate(index);
  }

}
